import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { getFeatureToggle } from '@capital-access/common/feature-toggle';
import { NavConfig, NavConfigFn, NavigationConfigProvider, BadgeType } from '@capital-access/common/navigation';
import { ADVANCED_SEARCH_FEATURE_TOGGLE, ADVANCED_SEARCH_PATH } from './constants';

@Injectable()
export class AdvancedSearchNavConfigProvider implements NavigationConfigProvider {
  constructor(private store: Store) {}

  resolveNavConfig: NavConfigFn = () => {
    return this.store.select(getFeatureToggle(ADVANCED_SEARCH_FEATURE_TOGGLE)).pipe(
      map(isEnabled => {
        return <NavConfig>{
          top: [
            {
              localizationKey: 'advancedSearch',
              icon: 'f-i-smart-search',
              order: 90,
              link: ADVANCED_SEARCH_PATH,
              enabled: isEnabled,
              badgeType: BadgeType.BadgeBeta
            }
          ]
        };
      })
    );
  };
}
